

<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)" [expanded]="panelOpenState()" id="main" class="border" #secondCommonExpansion>
    
    <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
      <div class="container-fluid" style="background: black; display: flex; align-items: center; justify-content: space-between;">
        <h5 class="mb-0 text-white">Reducer Selection</h5>
        <i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
    </mat-expansion-panel-header>

    <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
      <div class="container-fluid" style="background: #e2001a; display: flex; align-items: center; justify-content: space-between;">
        <h5 class="mb-0 text-white">Reducer Selection</h5>
        <i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
    </mat-expansion-panel-header>

    <!-- Hiding the selected series and size -->
        <div class="justify-content-center" *ngIf="signalStatus==true" style="margin-top: 15px;">
          <div class="table-responsive">
            
            <table class="table table-bordered text-center productTable">
              
              <thead>
                <tr>
                  <th scope="col">Series</th>
                  <th scope="col">Product</th>
                  <th scope="col">Product Spec Sheet Link</th>
                  <th scope="col">Construction</th>
                  <th scope="col" style="width: 110px;">Rated Mechanical Input Power</th>
                  <th scope="col" style="width: 110px;">Rated Thermal Input Power</th>
                  <th scope="col" style="width: 120px;">SF Based On Input Power</th>
                  <th scope="col">Center Distance</th>
                  <th scope="col">IP Rating</th>
                  <th scope="col" style="width: 95px;">Price Point</th>
                  <th scope="col">Warranty</th>
                </tr>
              </thead>
              <tbody>
                <tr class="seriesHPNOFAN" *ngIf="reducerData.IPPowerMech_ImpHPNoFan!=null">
                  <td scope="col" class="seriesHPNOFAN"><h5 style="width: 110px;">Fan-Cooled Series HP</h5></td>
                  <td class="seriesHPNOFAN"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_HP.png'" alt="Series HP" width="140" height="140" title="Series HP"><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('HPNOFAN')" style="background-color: #59842b; color: white;">
                  </td>
                  <td class="seriesHPNOFAN" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HP.pdf" target="_blank" title="Series HP Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HP.jpg'" alt="Series HP Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPNOFAN" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HP.pdf" target="_blank" title="Series HP Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HP.jpg'" alt="Series HP Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPNOFAN">Cast Iron</td>
                <td class="seriesHPNOFAN" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpHPNoFan +" kW"}} 
                </td>
                <td class="seriesHPNOFAN" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpHPNoFan +" HP"}} 
                </td>
                <td class="seriesHPNOFAN" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpHPNoFan +" kW"}} 
                </td>
                <td class="seriesHPNOFAN" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpHPNoFan +" HP"}} 
                </td>
                <!-- <td class="seriesHP">{{reducerData.IPPowerMech_ImpHp}}</td> -->
                <!-- <td class="seriesHPNOFAN">{{reducerData.IPPowerthermal_ImpHPNoFan}}</td> -->
                <td class="seriesHPNOFAN">{{reducerData.SfBasedOnIPHPNoFan}}</td>
                <td class="seriesHPNOFAN">{{reducerData.HPNoFanSize}}</td>
                <td class="seriesHPNOFAN">None</td>
                <td class="seriesHPNOFAN">Mid-Range</td>
                <td class="seriesHPNOFAN">5 Year</td>
                </tr>
                <tr class="seriesHP" *ngIf="reducerData.IPPowerMech_ImpHp!=null">
                  <td scope="col" class="seriesHP"><h5 style="width: 110px;">Series HP</h5></td>
                  <td class="seriesHP"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_HP.png'" alt="Series HP" width="140" height="140" title="Series HP"><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('HP')" style="background-color: #59842b; color: white;">
                  </td>
                  <td class="seriesHP" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HP.pdf" target="_blank" title="Series HP Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HP.jpg'" alt="Series HP Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHP" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HP.pdf" target="_blank" title="Series HP Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HP.jpg'" alt="Series HP Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHP">Cast Iron</td>
                <td class="seriesHP" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpHp +" kW"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpHp +" HP"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpHp +" kW"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpHp +" HP"}} 
                </td>
                <!-- <td class="seriesHP">{{reducerData.IPPowerMech_ImpHp}}</td> -->
                <!-- <td class="seriesHP">{{reducerData.IPPowerthermal_ImpHp}}</td> -->
                <td class="seriesHP">{{reducerData.SfBasedOnIP}}</td>
                <td class="seriesHP">{{reducerData.HPSize}}</td>
                <td class="seriesHP">None</td>
                <td class="seriesHP">Mid-Range</td>
                <td class="seriesHP">5 Year</td>
                </tr>
                <tr class="seriesHPANOFAN" *ngIf="reducerData.IPPowerthermal_ImpHpaNoFan!=null">
                  <td scope="col" class="seriesHPANOFAN"><h5 style="width: 111px;">Fan-Cooled Series HP-A</h5></td>
                  <td class="seriesHPANOFAN"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_HP-A.png'" alt="Series HP-A" width="140" height="140" title="Series HP-A" ><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('HPANOFAN')" style="background-color: #59842b; color: white;"></td>
                  <td class="seriesHPANOFAN" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HPA.pdf" target="_blank" title="Series HP-A Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HPA.jpg'" alt="Series HP-A Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPANOFAN" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HPA.pdf" target="_blank" title="Series HP-A Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HPA.jpg'" alt="Series HP-A Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPANOFAN">Cast Iron</td>
                <td class="seriesHPANOFAN" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpHpaNoFan +" kW"}} 
                </td>
                <td class="seriesHPANOFAN" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpHpaNoFan +" HP"}} 
                </td>
                <td class="seriesHPANOFAN" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpHpaNoFan +" kW"}} 
                </td>
                <td class="seriesHPANOFAN" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpHpaNoFan +" HP"}} 
                </td>
                <!-- <td class="seriesHPA">{{reducerData.IPPowerMech_ImpHPA}}</td> -->
                <!-- <td class="seriesHPANOFAN">{{reducerData.IPPowerthermal_ImpHpaNoFan}}</td> -->
                <td class="seriesHPANOFAN">{{reducerData.SfBasedOnIPHPANoFan}}</td>
                <td class="seriesHPANOFAN">{{reducerData.HPANOFAN}}</td>
                <td class="seriesHPANOFAN">None</td>
                <td class="seriesHPANOFAN">Mid-Range</td>
                <td class="seriesHPANOFAN">5 Year</td>
                </tr>
                <tr class="seriesHPA" *ngIf="reducerData.IPPowerMech_ImpHPA!=null">
                  <td scope="col" class="seriesHPA"><h5 style="width: 111px;">Series HP-A</h5></td>
                  <td class="seriesHPA"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_HP-A.png'" alt="Series HP-A" width="140" height="140" title="Series HP-A" ><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('HPA')" style="background-color: #59842b; color: white;"></td>
                  <td class="seriesHPA" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HPA.pdf" target="_blank" title="Series HP-A Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HPA.jpg'" alt="Series HP-A Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPA" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_HPA.pdf" target="_blank" title="Series HP-A Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_HPA.jpg'" alt="Series HP-A Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesHPA">Cast Iron</td>
                <td class="seriesHP" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpHPA +" kW"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpHPA +" HP"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpHPA +" kW"}} 
                </td>
                <td class="seriesHP" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpHPA +" HP"}} 
                </td>
                <!-- <td class="seriesHPA">{{reducerData.IPPowerMech_ImpHPA}}</td> -->
                <!-- <td class="seriesHPA">{{reducerData.IPPowerthermal_ImpHPA}}</td> -->
                <td class="seriesHPA">{{reducerData.SfBasedOnIPHPA}}</td>
                <td class="seriesHPA">{{reducerData.HPASize}}</td>
                <td class="seriesHPA">None</td>
                <td class="seriesHPA">Mid-Range</td>
                <td class="seriesHPA">5 Year</td>
                </tr>
                
                <tr class="seriesRG" *ngIf="reducerData.IPPowerMech_ImpRG!=null">
                  <td scope="col" class="seriesRG"><h5 style="width: 110px;">Series RG</h5></td>
                  <td class="seriesRG"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_RG.png'" alt="Series RG" width="140" height="140" title="Series RG"><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('RG')" style="background-color: #59842b; color: white;"></td>
                  <td class="seriesRG" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_RG.pdf" target="_blank" title="Series RG Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_RG.jpg'" alt="Series RG Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesRG" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_RG.pdf" target="_blank" title="Series RG Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_RG.jpg'" alt="Series RG Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesRG">Cast Iron</td>
                <td class="seriesRG" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpRG +" kW"}} 
                </td>
                <td class="seriesRG" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpRG +" HP"}} 
                </td>
                <td class="seriesRG" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpRG +" kW"}} 
                </td>
                <td class="seriesRG" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpRG +" HP"}} 
                </td>
                <!-- <td class="seriesRG">{{reducerData.IPPowerMech_ImpRG}}</td> -->
                <!-- <td class="seriesRG">{{reducerData.IPPowerthermal_ImpRG}}</td> -->
                <td class="seriesRG">{{reducerData.SfBasedOnIPRG}}</td>
                <td class="seriesRG">{{reducerData.RGSize}}</td>
                <td class="seriesRG">IP 65</td>
                <td class="seriesRG">Mid-Range</td>
                <td class="seriesRG">5 Year</td>
                </tr>
                <tr class="seriesF" *ngIf="reducerData.IPPowerMech_ImpF!=null">
                  <td scope="col" class="seriesF"><h5 style="width: 110px;">Series F</h5></td>
                  <td class="seriesF"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_F.png'" alt="Series F"  width="140" height="140" title="Series F"><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('F')" style="background-color: #59842b; color: white;"></td>
                  <td class="seriesF" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_F.pdf" target="_blank" title="Series F Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_F.jpg'" alt="Series F Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesF" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_F.pdf" target="_blank" title="Series F Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_F.jpg'" alt="Series F Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesF">Stainless Steel</td>
                <td class="seriesF" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpF +" kW"}} 
                </td>
                <td class="seriesF" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpF +" HP"}} 
                </td>
                <td class="seriesF" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpF +" kW"}} 
                </td>
                <td class="seriesF" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpF +" HP"}} 
                </td>
                <!-- <td class="seriesF">{{reducerData.IPPowerMech_ImpF}}</td> -->
                <!-- <td class="seriesF">{{reducerData.IPPowerthermal_ImpF}}</td> -->
                <td class="seriesF">{{reducerData.SfBasedOnIPF}}</td>
                <td class="seriesF">{{reducerData.FSizeOnly}}</td>
                <td class="seriesF">IP 69K</td>
                <td class="seriesF">Premium</td>
                <td class="seriesF">5 Year</td>
                </tr>
                <tr class="seriesB" *ngIf="reducerData.IPPowerMech_ImpB!=null">
                  <td scope="col" class="seriesB"><h5 style="width: 110px;">Series B</h5></td>
                  <td class="seriesB"><img [src]=" AssetbasePath + '/Content/ProductImage/Series_B.png'" alt="Series B" width="140" height="140" title="Series B"><input class="btn btn-primary w-100" type="button" value="Select" (click)="onButtonClick('B')" style="background-color: #59842b; color: white;"></td>
                  <td class="seriesB" *ngIf="showcdinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_B.pdf" target="_blank" title="Series B Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_B.jpg'" alt="Series B Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesB" *ngIf="showspinfo"><a href="{{ AssetbasePath }}/Content/Catalog/Series_B.pdf" target="_blank" title="Series B Spec Sheet">
                    <img [src]=" AssetbasePath + '/Content/Catalog/Series_B.jpg'" alt="Series B Spec Sheet Icon" width="118" height="153" /></a>
                </td>
                <td class="seriesB">Aluminum</td>
                <td class="seriesB" *ngIf="units=='metric'">
                  {{reducerData.IPPowerMech_ImpB +" kW"}} 
                </td>
                <td class="seriesB" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerMech_ImpB +" HP"}} 
                </td>
                <td class="seriesB" *ngIf="units=='metric'">
                  {{reducerData.IPPowerthermal_ImpB +" kW"}} 
                </td>
                <td class="seriesB" *ngIf="units=='imperial'">
                  {{reducerData.IPPowerthermal_ImpB +" HP"}} 
                </td>
                <!-- <td class="seriesB">{{reducerData.IPPowerMech_ImpB}}</td> -->
                <!-- <td class="seriesB">{{reducerData.IPPowerthermal_ImpB}}</td> -->
                <td class="seriesB">{{reducerData.SfBasedOnIPB}}</td>
                <td class="seriesB">{{reducerData.BSizeOnly}}</td>
                <td class="seriesB">IP 55</td>
                <td class="seriesB">Economy</td>
                <td class="seriesB">2 Year</td>
                </tr>
              </tbody>
            </table>
          </div>
          
      
      </div>
    

 <div *ngIf="signalStatus==false">
  <h4 style="color: red;">Please proceed from previous step</h4>
 </div>

</mat-expansion-panel>
</mat-accordion>